import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { LOGOUT_SUCCESS, RESET_TO_INITIAL_STATE } from "./auth";
var LOAD_FROM_SF = "likeablelocal/newContract/LOAD_FROM_SF";
var LOAD_FROM_SF_SUCCESS = "likeablelocal/newContract/LOAD_FROM_SF_SUCCESS";
var LOAD_FROM_SF_FAIL = "likeablelocal/newContract/LOAD_FROM_SF_FAIL";
var SAVE_CONTRACT = "likeablelocal/newContract/SAVE_CONTRACT";
var SAVE_CONTRACT_SUCCESS = "likeablelocal/newContract/SAVE_CONTRACT_SUCCESS";
var SAVE_CONTRACT_FAIL = "likeablelocal/newContract/SAVE_CONTRACT_FAIL";
var IS_SAVE_EDITS = "likeablelocal/newContract/IS_SAVE_EDITS";
var IS_SAVE_EDITS_SUCCESS = "likeablelocal/newContract/IS_SAVE_EDITS_SUCCESS";
var IS_SAVE_EDITS_FAIL = "likeablelocal/newContract/IS_SAVE_EDITS_FAIL";
var SEND_EMAIL = "likeablelocal/newContract/SEND_EMAIL";
var SEND_EMAIL_SUCCESS = "likeablelocal/newContract/SEND_EMAIL_SUCCESS";
var SEND_EMAIL_FAIL = "likeablelocal/newContract/SEND_EMAIL_FAIL";
var SET_STEP = "likeablelocal/newContract/SET_STEP";
var DOWNLOAD_AGREEMENT = "likeablelocal/newContract/DOWNLOAD_AGREEMENT";
var initialState = {
  saveError: null,
  step: 1,
  isLoadingFromSf: false,
  saving: false,
  agreement: null
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case RESET_TO_INITIAL_STATE:
    case LOGOUT_SUCCESS:
      return initialState;

    case LOAD_FROM_SF:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingFromSf: true
      });

    case LOAD_FROM_SF_SUCCESS:
      var data = action.result.data;
      var formValues = {
        sfid: data.Id,
        email: data.Account_Email__c,
        firstName: data.Main_Contact__c.split(" ")[0],
        lastName: data.Main_Contact__c.split(" ")[1],
        businessName: data.Name,
        address1: data.BillingStreet,
        locality: data.BillingCity,
        region: data.BillingState,
        postcode: data.BillingPostalCode,
        phone: data.Phone
      };
      return _objectSpread(_objectSpread({}, state), {}, {
        data: formValues,
        isLoadingFromSf: false
      });

    case LOAD_FROM_SF_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingFromSf: false
      });

    case SAVE_CONTRACT:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingContract: true
      });

    case SAVE_CONTRACT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingContract: false
      });

    case SAVE_CONTRACT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        savingContract: false
      });

    case SEND_EMAIL:
      return state;

    case SEND_EMAIL_SUCCESS:
      return state;

    case IS_SAVE_EDITS:
      return _objectSpread(_objectSpread({}, state), {}, {
        saving: true,
        saveError: null
      });

    case IS_SAVE_EDITS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        saving: false
      });

    case IS_SAVE_EDITS_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        saving: false,
        saveError: action.error
      });

    case SEND_EMAIL_FAIL:
      return state;

    case SET_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        step: action.step
      });

    case DOWNLOAD_AGREEMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        agreement: action.data
      });

    default:
      return state;
  }
}
export function addContract(data) {
  return {
    types: [SAVE_CONTRACT, SAVE_CONTRACT_SUCCESS, SAVE_CONTRACT_FAIL],
    promise: function promise(client) {
      return client.post("/contract", {
        data: data
      });
    }
  };
}
export function editContract(data) {
  return {
    types: [IS_SAVE_EDITS, IS_SAVE_EDITS_SUCCESS, IS_SAVE_EDITS_FAIL],
    promise: function promise(client) {
      return client.put("/contract", {
        data: data
      });
    }
  };
}
export function sendAgreementEmail(data) {
  return {
    types: [SEND_EMAIL, SEND_EMAIL_SUCCESS, SEND_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post("/sendAgreementEmail", {
        data: data
      });
    }
  };
}
export function downloadAgreement(id) {
  return {
    types: [DOWNLOAD_AGREEMENT, DOWNLOAD_AGREEMENT, DOWNLOAD_AGREEMENT],
    promise: function () {
      var _promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", client.get("/download/s3File/".concat(id)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function promise(_x) {
        return _promise.apply(this, arguments);
      }

      return promise;
    }()
  };
} // todo hugh will delete this

export function loadFromSFId(sfid) {
  return {
    types: [LOAD_FROM_SF, LOAD_FROM_SF_SUCCESS, LOAD_FROM_SF_FAIL],
    promise: function promise(client) {
      return client.get("/sfinfo/load/".concat(sfid));
    }
  };
}
export function setStep(step) {
  return {
    type: SET_STEP,
    step: step
  };
}